import { formatDate } from "../utils/format-utils";
import store from "../store/index";

import Assignment from "./Assignment";
import Transmittal from "./Transmittal";

export default class ServicePlan {
  servicePlanId?: number | null;
  planId?: number | null;
  clientId?: number | null;
  omniSiteId?: number | null;
  programId?: number | null;
  program?: string | null;
  serviceId?: number | null;
  service?: string | null;
  sessionLocationId?: number | null;
  sessionLocation?: string | null;
  createdOn?: Date | null;
  startDate?: Date | null;
  endDate?: Date | null;
  groupSize?: number | null;
  frequency?: number | null;
  durationMinutes?: number | null;
  icdCode?: string | null;
  eiAuthorizationNumber?: string | null;
  unitCount?: number | null;
  isLocationChangeAllowed?: boolean | null;
  psnLanguageId?: number | null;
  isCompensatorySummer?: boolean | null;
  // set only from the transmittal accept flow; read-only in the plan editor
  isDuplicatePerDistrict?: boolean | null;
  transmittal?: Transmittal | null;
  assignments?: Assignment[] | null;

  public constructor(params: ServicePlan = {} as ServicePlan) {
    let {
      servicePlanId = 0,
      planId = null,
      clientId = null,
      omniSiteId = null,
      programId = null,
      program = null,
      serviceId = null,
      service = null,
      sessionLocationId = null,
      sessionLocation = null,
      createdOn = null,
      startDate = null,
      endDate = null,
      groupSize = null,
      frequency = null,
      durationMinutes = null,
      icdCode = null,
      eiAuthorizationNumber = null,
      unitCount = null,
      isLocationChangeAllowed = null,
      psnLanguageId = null,
      isCompensatorySummer = null,
      isDuplicatePerDistrict = false,
      transmittal = null,
      assignments = null,
    } = params;
    this.servicePlanId = servicePlanId;
    this.planId = planId;
    this.clientId = clientId;
    this.omniSiteId = omniSiteId;
    this.programId = programId;
    this.program = program;
    this.serviceId = serviceId;
    this.service = service;
    this.sessionLocationId = sessionLocationId;
    this.sessionLocation = sessionLocation;
    this.createdOn = createdOn;
    this.startDate = startDate;
    this.endDate = endDate;
    this.groupSize = groupSize;
    this.frequency = frequency;
    this.durationMinutes = durationMinutes;
    this.icdCode = icdCode;
    this.eiAuthorizationNumber = eiAuthorizationNumber;
    this.unitCount = unitCount;
    this.isLocationChangeAllowed = isLocationChangeAllowed;
    this.psnLanguageId = psnLanguageId;
    this.isCompensatorySummer = isCompensatorySummer;
    this.isDuplicatePerDistrict = isDuplicatePerDistrict;
    this.transmittal = transmittal && new Transmittal(transmittal);
    this.assignments =
      assignments && assignments.map((item) => new Assignment(item));
  }
  get formattedStartDate() {
    return formatDate(this.startDate);
  }
  get formattedEndDate() {
    return formatDate(this.endDate);
  }
  get mandate() {
    if (Boolean(this.frequency) && Boolean(this.durationMinutes))
      return (
        this.frequency + " x " + this.durationMinutes + " : " + this.groupSize
      );
    return "";
  }

  get programCode() {
    return store.getters["optionsModule/getProgramCode"](this.programId);
  }
  get isSeitOrPend() {
    return ["SEIT", "PEND"].includes(this.programCode);
  }
  get isRelatedServices() {
    return ["CPF", "CS", "RS"].includes(this.programCode);
  }
  // the related services BOE contracts out to us, service by service
  get isContractedService() {
    return ["CPF", "CS"].includes(this.programCode);
  }
  // programs whose provider assignments are managed in-app (created/edited/
  // deleted directly) rather than imported from BOE
  get hasManagedAssignments() {
    return this.isSeitOrPend || this.isRelatedServices;
  }
  // a linked transmittal is BOE assigning the service to Omni
  get isAssignedToOmni() {
    return Boolean(this.transmittal);
  }
  // contracted services are ours to staff only once assigned to Omni
  get canCreateAssignments() {
    return (
      this.hasManagedAssignments &&
      (!this.isContractedService || this.isAssignedToOmni)
    );
  }
  get currentAssignments() {
    let today = new Date();
    return (
      this.assignments &&
      this.assignments.filter(
        (x) =>
          !x.isSubstitute &&
          x.approvalStartDate != null &&
          new Date(x.approvalStartDate) <= today &&
          x.approvalEndDate != null &&
          new Date(x.approvalEndDate) >= today &&
          (x.endDate == null || new Date(x.endDate) >= today)
      )
    );
  }

  get isPartialMandate() {
    return (
      this.transmittal?.frequency &&
      this.frequency &&
      this.transmittal?.frequency < this.frequency
    );
  }

  get transmittalMandate() {
    if (
      Boolean(this.transmittal?.frequency) &&
      Boolean(this.transmittal?.durationMinutes)
    )
      return (
        this.transmittal?.frequency +
        " x " +
        this.transmittal?.durationMinutes +
        " : " +
        this.transmittal?.groupSize
      );
    return "";
  }
}
